import React, { useState } from 'react';
import DashboardWidgetNew from './DashboardWidgetNew';

const Tags = () => {
  const [filters, setFilters] = useState({});

  const getChartTitle = filters => {
    if (filters.operation === 'investment') {
      return 'Organization Based Investment Trend ($)';
    }
    if (filters.operation === 'git_effort') {
      return 'Organization Based Effort Trend';
    }
    return 'Organization Based Commit';
  };

  const dashboardFilters = filter => {
    setFilters(filter);
  };

  return (
    <DashboardWidgetNew
      category="tags"
      serviceURL="/dashboard/get-table-data-tags"
      dashboardFilters={dashboardFilters}
      isHidden={['tags']}
      forceClearMultiFilters={['tags']}
      title={{
        chartTitle: getChartTitle(filters),
        pieTitle: 'Tags - Pie',
        tableColumnName: 'Tags'
      }}
    />
  );
};

export default Tags;
